import { render, staticRenderFns } from "./FilterComponent.vue?vue&type=template&id=0b96b59c"
import script from "./FilterComponent.vue?vue&type=script&lang=js"
export * from "./FilterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports